































import {
  defineComponent,
  computed
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'RadioBox',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    additional: {
      type: String,
      default: ''
    },
    select: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const isChecked = computed(() => props.value === props.select)

    const inputHandler = () => {
      emit('input', props.select)
    }

    return {
      isChecked,
      inputHandler
    }
  }
})
